import fetch from './fetch'

export default {
  getPersonExternalIds (payload) {
    if (!payload.eperson) {
      console.log('No person id provided for requesting external ids')
      return
    }

    let request = fetch({
      url: `/personextid`,
      method: 'get',
      data: {},
      payload: payload
    })
    return request.call()
  },
  createExternalId (payload) {
    let request = fetch({
      url: `/personextid`,
      method: 'post',
      data: payload,
      payload: {}
    })
    return request.call()
  }
}



// WEBPACK FOOTER //
// ./src/api/externalids.js